import "./ExperienceDetail.scss";

const AME = () => {
  return (
    <div className="experience-detail">
      <div className="experience-detail__container">
        <div className="experience-detail__header">
          <span className="experience-detail__tenure">
            April 2020 - September 2021
          </span>
          <h1 className="experience-detail__title">Web Developer at AME</h1>
        </div>

        <div className="experience-detail__content">
          <section className="experience-detail__section">
            <h2>Overview</h2>
            <p>
              Worked within a WordPress CMS creating a bespoke system for
              students in Medical School to sign up and take online mock exams
              and watch courses related to their field of expertise.
            </p>
          </section>

          <section className="experience-detail__section">
            <h2>Responsibilities</h2>
            <ul>
              <li>
                Developing custom WordPress solutions for medical education
              </li>
              <li>Building online examination and course delivery systems</li>
              <li>Creating user registration and management features</li>
              <li>
                Ensuring content is accessible and easy to navigate for medical
                students
              </li>
              <li>Working with educational content and assessment tools</li>
            </ul>
          </section>

          <section className="experience-detail__section">
            <h2>Tech Stack</h2>
            <div className="experience-detail__tags">
              <span className="experience-detail__tag">WordPress</span>
              <span className="experience-detail__tag">PHP</span>
              <span className="experience-detail__tag">JavaScript</span>
              <span className="experience-detail__tag">CSS</span>
              <span className="experience-detail__tag">MySQL</span>
            </div>
          </section>
        </div>

        <a href="/" className="experience-detail__back-link">
          ← Back to Portfolio
        </a>
      </div>
    </div>
  );
};

export default AME;
